<!-- =========================================================================================
    File Name: TheFooter.vue
    Description: Footer component
    Component Name: TheFooter
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template functional>
    
</template>

<script>
export default {
    name: "the-footer",
    props: {
        classes: {
            type: String,
        },              //<footer class="the-footer flex-wrap justify-between pt-0" :class="classes">
       // <span>COPYRIGHT @ {{ new Date().getFullYear() }} <a href="" target="_blank" rel="nofollow">Picksoft</a>, Tüm Hakları Saklıdır.</span>
    //</footer>
    }
}
</script>
